import { render, staticRenderFns } from "./Complaint.vue?vue&type=template&id=75d811f6&scoped=true&"
import script from "./Complaint.vue?vue&type=script&lang=js&"
export * from "./Complaint.vue?vue&type=script&lang=js&"
import style0 from "./Complaint.vue?vue&type=style&index=0&id=75d811f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d811f6",
  null
  
)

export default component.exports